import { IProduct } from '../../interfaces'
import { extraId } from '../../graphQL/queries/getSession/types'
import { BannerData } from '../../interfaces/banners'
export enum EEventTypes {
  INTERACTION = 'INTERACTION',
  PAGE_VIEW = 'PAGE_VIEW',
  STEP = 'STEP',
}

export type TEventNames =
  | 'addToCart'
  | 'removeFromCart'
  | 'clearCart'
  | 'deleteFromCart'
  | 'pageView'
  | 'checkoutStep'
  | 'webviewClosed'
  | 'clickAddToCartOnPrefill'
  | 'clickRemoveFromCartOnPrefill'
  | 'addToCartPrefilledItems'
  | 'closeModal'
  | 'openModal'
  | 'bannerClick'
  | 'clickGoBack'

export type EEventNames = {
  [key in TEventNames]: key
}

export const eventNames: EEventNames = {
  addToCart: 'addToCart',
  removeFromCart: 'removeFromCart',
  clearCart: 'clearCart',
  deleteFromCart: 'deleteFromCart',
  pageView: 'pageView',
  checkoutStep: 'checkoutStep',
  webviewClosed: 'webviewClosed',
  clickAddToCartOnPrefill: 'clickAddToCartOnPrefill',
  clickRemoveFromCartOnPrefill: 'clickRemoveFromCartOnPrefill',
  addToCartPrefilledItems: 'addToCartPrefilledItems',
  openModal: 'openModal',
  closeModal: 'closeModal',
  bannerClick: 'bannerClick',
  clickGoBack: 'clickGoBack',
}

export interface IGlobalSchema {
  eventType: keyof typeof EEventTypes
  storefront?: string
  eventName?: string
  phoneNumber: string
  sessionId: string
  // name of the window or modal in wich was triggered the event call
  viewName: string
  // used for track checkout steps where step 1 is catalogue view  and step 4 is confirm order modal
  payload?: ICartSchema | ITrackCheckoutStepSchema | IPageView | {}
  errors?: string[]
  extraIds?: extraId[]
}

export type IProductGenericBase = Pick<
  IProduct,
  'quantity' | 'name' | 'brand' | 'id' | 'price' | 'category' | 'sku'
>

interface ICartSchema {
  cart: {
    products?: IProductGenericBase[]
    product?: IProductGenericBase | null
    currency?: string
    total: number
    totalItems: number
  }
}

interface ITrackCheckoutStepSchema {
  step: number
  stepName?: string
}

export type TPageViewAction = 'open' | 'close'

export const pageViewActions: { [key in TPageViewAction]: key } = {
  open: 'open',
  close: 'close',
}

interface IPageView {
  isModal: boolean
  action?: TPageViewAction
}

export interface IBaseEventPayload {
  eventName: TEventNames
  phoneNumber: string
  sessionId: string
  viewName: string
  storefront: string
  extraIds: extraId[]
}

export interface ITrackClickEventPayload extends IBaseEventPayload {
  payload: ICartSchema
}

export interface ITrackCartEventPayload extends IBaseEventPayload {
  cartData: ICartSchema
}

export interface ITrackCheckoutStepPayload extends IBaseEventPayload {
  stepData: ITrackCheckoutStepSchema
}

export interface ITrackBannerClickPayload
  extends Pick<IBaseEventPayload, 'eventName' | 'viewName'> {
  bannerData: BannerData
}

export interface ITrackPageViewPayload
  extends Pick<IBaseEventPayload, 'eventName' | 'viewName'> {
  pageData: IPageView
}

export type SchemaBatch = IGlobalSchema[]
